import { mapState } from 'vuex'

export default {
  name: 'FormatService',
  computed: {
    ...mapState([
      'branchTranslations',
      'selectedLanguage',
      'messages'
    ])

  },
  watch: {
    selectedLanguage () {
    }
  },
  methods: {
    getBranchAddress:
    function (branch, place) {
      var order = this.messages[place]
      var separator = this.messages.branchSeparator
      if (separator === undefined || place === 'branchSelected' || place === 'branchShortAddress') {
        separator = ', '
      }
      if (separator === ',') {
        separator = ', '
      }
      if (order === null || order === undefined) {
        if (place === 'branchFullAddress') { order = 'branchAddress1,branchAddress2,branchCity,branchZip' } else if (place === 'branchSelected') { order = 'branchName,branchCity' } else if (place === 'branchShortAddress') { order = 'branchAddress1,branchCity,branchZip' } else { order = 'branchAddress1, branchCity, branchZip' }
      }
      var entries = order.split(',')
      var formatted = ''
      for (var key in entries) {
        var entry = entries[key].trim()
        if (entry === 'branchName') {
          formatted = this.branchTranslations[branch.id] && this.branchTranslations[branch.id].names && this.branchTranslations[branch.id].names[this.selectedLanguage.lang] ? this.branchTranslations[branch.id].names[this.selectedLanguage.lang] : branch.name
          formatted += separator
        } else if (entry === 'branchAddress1') {
          var address1 = this.branchTranslations[branch.id] && this.branchTranslations[branch.id].address && this.branchTranslations[branch.id].address[this.selectedLanguage.lang] && this.branchTranslations[branch.id].address[this.selectedLanguage.lang].address1 ? this.branchTranslations[branch.id].address[this.selectedLanguage.lang].address1 : branch.addressLine1
          if (address1) {
            formatted += address1
            formatted += separator
          }
        } else if (entry === 'branchAddress2') {
          var address2 = this.branchTranslations[branch.id] && this.branchTranslations[branch.id].address && this.branchTranslations[branch.id].address[this.selectedLanguage.lang] && this.branchTranslations[branch.id].address[this.selectedLanguage.lang].address2 ? this.branchTranslations[branch.id].address[this.selectedLanguage.lang].address2 : branch.addressLine2
          if (address2) {
            formatted += address2
            formatted += separator
          }
        } else if (entry === 'branchCity') {
          var city = this.branchTranslations[branch.id] && this.branchTranslations[branch.id].address && this.branchTranslations[branch.id].address[this.selectedLanguage.lang] && this.branchTranslations[branch.id].address[this.selectedLanguage.lang].city ? this.branchTranslations[branch.id].address[this.selectedLanguage.lang].city : branch.addressCity
          if (city) {
            formatted += city
            formatted += separator
          }
        } else if (entry === 'branchZip' && branch.addressZip) {
          formatted += branch.addressZip + separator
        } else if (entry === 'branchEmail' && branch.email) {
          formatted += branch.email + separator
        } else if (entry === 'branchPhone' && branch.phone) {
          formatted += branch.phone + separator
        }
      }

      formatted = formatted.substring(0, formatted.length - separator.length)
      return formatted
    },
    getBranchAddressBranchCard:
    function (branch) {
      var separator = this.messages.branchSeparator
      if (separator === undefined || separator === ',') {
        separator = ', '
      }
      var formatted = this.branchTranslations[branch.id] && this.branchTranslations[branch.id].address && this.branchTranslations[branch.id].address[this.selectedLanguage.lang] && this.branchTranslations[branch.id].address[this.selectedLanguage.lang].address1 ? this.branchTranslations[branch.id].address[this.selectedLanguage.lang].address1 : branch.addressLine1
      var address2 = this.branchTranslations[branch.id] && this.branchTranslations[branch.id].address && this.branchTranslations[branch.id].address[this.selectedLanguage.lang] && this.branchTranslations[branch.id].address[this.selectedLanguage.lang].address2 ? this.branchTranslations[branch.id].address[this.selectedLanguage.lang].address2 : branch.addressLine2
      if (address2) { formatted += separator + address2 }
      if (branch.addressZip) { formatted += separator + branch.addressZip }
      var city = this.branchTranslations[branch.id] && this.branchTranslations[branch.id].address && this.branchTranslations[branch.id].address[this.selectedLanguage.lang] && this.branchTranslations[branch.id].address[this.selectedLanguage.lang].city ? this.branchTranslations[branch.id].address[this.selectedLanguage.lang].city : branch.addressCity
      if (city) { formatted += separator + city }
      return formatted
    },
    getServiceName: function (service) {
      return service.custom !== undefined && service.custom.names !== undefined && service.custom.names[this.selectedLanguage.lang] ? service.custom.names[this.selectedLanguage.lang] : service.name
    }
  }
}
